module.exports = __webpack_public_path__ + "img/CommunityManagement.df1d613d.jpg";